// Badge variant helpers shared by SettingsRegistryTable/Row/Drilldown.
export function kindBadgeVariant(kind: string): 'secondary' | 'info' {
    return kind === 'flag' ? 'info' : 'secondary'
}

export function stageBadgeVariant(stage: string): 'secondary' | 'info' | 'success' {
    switch (stage) {
        case 'server':
            return 'success'
        case 'org':
            return 'info'
        default:
            return 'secondary'
    }
}

export function visibilityBadgeVariant(visibility: string): 'secondary' | 'info' | 'warning' | 'destructive' {
    switch (visibility) {
        case 'public':
            return 'info'
        case 'internal':
            return 'secondary'
        case 'private':
        case 'system':
            return 'warning'
        case 'secret':
            return 'destructive'
        default:
            return 'secondary'
    }
}

const STALE_THRESHOLD_MS = 30 * 24 * 60 * 60 * 1000 // 30 days

/** isStale reports whether a code's last_read_at makes it a dead-code candidate: never read, or not read in over 30 days. */
export function isStale(lastReadAt: string | null | undefined): boolean {
    if (!lastReadAt) return true
    const readAt = new Date(lastReadAt).getTime()
    if (Number.isNaN(readAt)) return true
    return Date.now() - readAt > STALE_THRESHOLD_MS
}
